module.exports = __webpack_public_path__ + "static/video 3-ae47824f9035c97eee7ad837e493dc13.jpg";